export const chart_record = {
  OPEN_TIME: "open_time",
  OPEN_PRICE: "open_price",
  CLOSE_PRICE: "close_price",
  LOW_PRICE: "low_price",
  HIGH_PRICE: "high_price",
};
